/* eslint-disable no-magic-numbers */

export function mathJaxToEnglish(s: string) {
  //num and some fraction-- > num and that fraction
  s = s.replace(
    /\\large(\d+)(?=\\frac\\?)/gi,
    (_m, m1: string) => `${m1} and `,
  );

  //strip any remaining large tags
  s = s.replace(/\\large/gi, '');

  //roman text
  s = s.replace(/\\rm/gi, '');

  //space
  s = s.replace(/\\space/gi, '');

  //lines, rays, and that kind of thing
  s = s.replace(/\\overleftrightarrow/gi, ' line ');
  s = s.replace(/\\overline/gi, ' line segment ');
  s = s.replace(/\\(overleftarrow|overrightarrow)/gi, ' ray ');

  //replace times tag with the word times
  s = s.replace(/\s*\\times\s*/gi, ' times ');

  //what we're using for degrees
  s = s.replace(/\^\{\\circ\}/gi, ' degrees ');

  //replace hyphen with minus
  s = s.replace(/\s*-\s*/gi, ' minus ');

  //replace > with greater than
  s = s.replace(/\s*>\s*/gi, ' greater than ');

  //replace hyphen with minus
  s = s.replace(/\s*<\s*/gi, ' less than ');

  //handle simple fractions
  s = s.replace(
    /\s*\\frac\\?\{(\d+)\}\{(\d+)\}\s*/gi,
    (_m, num: string, den: string) => {
      const numAsNumber = parseInt(num);
      const denAsNumber = parseInt(den);

      if (1 < denAsNumber && denAsNumber <= 10) {
        return ` ${num} ${toOrdinalFractionDenominator(numAsNumber, denAsNumber)} `;
      }

      return ` ${num} divided by ${den} `;
    },
  );

  return s;
}

export function mathJaxToEnglishAll(s: string) {
  //____ --> "blank"
  s = s.replace(/_+/gi, ' blank ');

  //¢ --> cents (but what about 1¢ ?)
  s = s.replace(/\s*¢\s*/gi, ' cents ');
  s = s.replace(/\s*&cent;\s*/gi, ' cents ');

  s = s.replace(/~~(.+?)~~/gi, (_m, m1: string) => mathJaxToEnglish(m1));

  //replace html tags with nothing
  s = s.replace(/<.+?>/gi, '');

  return s;
}

function toOrdinalFractionDenominator(n: number, d: number): string {
  switch (d) {
    case 2:
      return noun(n, 'half', 'halves');
    case 3:
      return noun(n, 'third', 'thirds');
    case 4:
      return noun(n, 'quarter', 'quarters');
    case 5:
      return noun(n, 'fifth', 'fifths');
    case 6:
      return noun(n, 'sixth', 'sixths');
    case 7:
      return noun(n, 'seventh', 'sevenths');
    case 8:
      return noun(n, 'eighth', 'eighths');
    case 9:
      return noun(n, 'ninth', 'ninths');
    case 10:
      return noun(n, 'tenth', 'tenths');
    default:
      throw new Error('Unsupported denominator');
  }
}

function noun(n: number, singular: string, plural: string) {
  return n === 1 ? singular : plural;
}
